import { render, staticRenderFns } from "./DeviceManage.vue?vue&type=template&id=51c22c3c&scoped=true&"
import script from "./DeviceManage.vue?vue&type=script&lang=js&"
export * from "./DeviceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c22c3c",
  null
  
)

export default component.exports